export function lifeCycleFactory(document) {
  return {
    createPopover() {
      const popover = document.createElement("div");
      popover.setAttribute("id", "kontribut-selection-frame");
      popover.setAttribute(
        "style",
        "position: absolute; width: 20; height: 20;user-select: none; border: 1px dashed rgba(125, 125, 125, 0.5); pointer-events: none;"
      );
      popover.innerHTML = "&nbsp;";
      return popover;
    },
    attachPopover(popover) {
      document.body.appendChild(popover);
    },
    removePopover(popover) {
      const parent = popover.parentNode;
      if (parent) parent.removeChild(popover);
    },
  };
}
